import { Head } from "blitz"

export const NoIndex = () => (
  <Head>
    <meta content="noindex" name="robots" />
  </Head>
)
